<template>
  <div class="baniere">
    <div class="blocc md:pt-10 pt-6">
      <img
        src="../../../assets/images/webp/bank.webp"
        alt=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
    </div>

    <div class="md:flex mt-16">
      <div class="md:w-1/3 w-full">
        <services
          icon="ic_entreprise"
          label="Au service des particuliers, des PME et des entreprises."
          data-aos="fade-up"
          data-aos-duration="1000"
        />

        <services
          class="mt-4"
          icon="ic_setting"
          label="Gestion flexible et configurable des produits de prêts"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <services
          class="mt-4"
          icon="ic_money_var"
          label="Prise en charge d'un large éventail de types de prêts aux entreprises"
          data-aos="fade-up"
          data-aos-duration="2200"
        />

        <services
          class="mt-4"
          icon="ic_suivi"
          label="Vue d'ensemble et suivi à 360 degrés"
          data-aos="fade-up"
          data-aos-duration="2300"
        />

        <services
          class="mt-4"
          icon="ic_espece"
          label="Des prêts en espèces aux prêts hypothécaires en passant par les lignes de crédit renouvelables."
          data-aos="fade-up"
          data-aos-duration="2400"
        />

        <services
          class="mt-4"
          icon="ic_touch"
          label="Possibilité d'extension avec d'autres produits de prêt ou des produits tiers."
          data-aos="fade-up"
          data-aos-duration="2500"
        />

        <services
          class="mt-4"
          icon="ic_saas"
          label="Fourni sur site ou en tant que SAAS"
          data-aos="fade-up"
          data-aos-duration="2500"
        />

        <services
          class="mt-4"
          icon="ic_menu_b"
          label="Interfaces intuitives offrant une excellente expérience client"
          data-aos="fade-up"
          data-aos-duration="2500"
        />

        <services
          class="mt-4"
          icon="ic_multicanal"
          label="Approche multicanale"
          data-aos="fade-up"
          data-aos-duration="2500"
        />
      </div>

      <div
        class="md:w-2/3 md:pl-20 detail md:mt-0 mt-10"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        Cet ensemble d'outils innovants, flexibles et unifiés aidera votre organisation à relever les défis actuels et futurs du monde bancaire. Les utilisateurs accrédités peuvent définir et maintenir des flux de travail, configurer des règles commerciales, des écrans et modifier eux-mêmes la mise en page.
        <br>
        <br>
        <p>
          La plateforme de gestion numérique des prêts met en œuvre une administration complète des produits de crédit, offre un traitement des frais, une génération facile de documents et une intégration native au système de gestion numérique des garanties de 41DEVS pour rendre votre activité de prêt aussi fluide et transparente que jamais auparavant. 41DEVS propose sa gestion numérique des prêts principalement sous forme de SaaS (Software as a Service) et de solutions sur site sur demande. La solution est agnostique et peut s'appuyer sur les technologies natives d'AWS, Azure ou Google Cloud Platform.
        </p>
      </div>
    </div>

    <divider
      height="10px"
      color="#EAEEFA"
      class="md:mt-20 mt-16"
      data-aos="fade-right"
      data-aos-duration="2000"
    />
  </div>
</template>

<script>
import services from '@/components/cedo/banking/services'
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    services,
    divider
  },
  props: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
   padding-bottom: 50px;
 }
 img{
   position: relative;
 }
  .blocc{
    height: auto;
  }
  .detail{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }

  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 10px;
    }
    .detail{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 30px;
    }
    .detail{
      font-size: 22px;
    }
    .titre1{
      font-size: 20px;
    }

    .blocc {
      padding: 30px;
    }
  }
</style>
